import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'irembogov-pagination',
  templateUrl: './irembo-pagination.component.html',
  styleUrls: ['./irembo-pagination.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IremboPaginationComponent implements OnInit, OnChanges {
  @Input() collectionSize!: number;
  @Input() pageSizes: number[] = [10, 20, 30];
  @Input() pageSize: number = this.pageSizes[0] || 10;
  @Input() maxSize = 7;
  @Input() showDropdown = true;
  @Input() showDirectionText = true;
  @Input() paginationDisplaySize: 'sm' | 'lg' | string | null = null;
  @Input() minimalPagination = false;
  @Output() paginatedValues = new EventEmitter();
  @Input() page = 1;
  @Input() isSlice = false;
  @Input() isLastPage = false;
  pagination = { pageNumber: 1, pageSize: this.pageSizes[0] || 10 };

  ngOnInit(): void {
    const effectivePageSize =
      this.pageSize ?? (this.pageSizes?.length ? this.pageSizes[0] : 10);

    this.pageSize = effectivePageSize;
    this.pagination.pageSize = effectivePageSize;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['pageSize'] && !!changes['pageSize']?.currentValue) {
      this.pagination = {
        ...this.pagination,
        pageSize: changes['pageSize']?.currentValue,
      };
    }
  }

  getPageSymbol(current: number) {
    return current;
  }

  pageChange(pageNumber: number): void {
    // ngb-pagination is bound one-way ([page], not [(page)]) — combining
    // two-way box syntax with this explicit (pageChange) handler on the same
    // element silently broke both: neither ever fired on a real click (only
    // ngb-pagination's own internal state updated). We own `page` fully now.
    this.page = pageNumber;
    this.pagination.pageNumber = pageNumber;
    this.paginate();
  }

  pageSizeChange(pageSize: number): void {
    this.pagination.pageSize = pageSize;
    this.paginate();
  }

  paginate(): void {
    this.paginatedValues.emit(this.pagination);
  }

  getTotalPages(): number {
    return Math.ceil(this.collectionSize / this.pageSize);
  }

  nextSlicePage() {
    if (!this.isLastPage) {
      this.pageChange(this.page + 1);
    }
  }

  previousSlicePage() {
    if (this.page > 1) {
      this.pageChange(this.page - 1);
    }
  }
}
